import ViewListOutlinedIcon from '@material-ui/icons/ViewListOutlined';
import EtiquetasCreate from './EtiquetasCreate';
import EtiquetasList from './EtiquetasList';
import EtiquetasShow from './EtiquetasShow';

const Etiquetas = {
    icon: ViewListOutlinedIcon,
    list: EtiquetasList,
    show: EtiquetasShow,
    create: EtiquetasCreate
};

export default Etiquetas;
